module.exports = __webpack_public_path__ + "static/media/Jack_Avatar_x2.d5546226.png";